$ = jQuery;

$(document).ready(function($) {
    $('.video-holder .trigger').on('click', function(ev) {

        $(".video-holder iframe")[0].src += "?autoplay=1";
        ev.preventDefault();

        $('.video-holder .overlay').fadeOut(2000);
        $('.video-holder .trigger').fadeOut(2000);
    });

    $('.drop-link').on('click', function (e) {
        e.preventDefault();
        var target = '.fullscreen-dropdown';
        if(this.dataset.id !== undefined) {
            target = '#' + this.dataset.id;
        }

        $(target).addClass('active');
    });
    $('.fullscreen-dropdown .close').on('click', function () {
        $('.fullscreen-dropdown').removeClass('active');
    });


    // $(".video-holder #fade-video").addEventListener("onStateChange", function(state){
    //     if(state === 0){
    //             $('.video-holder .overlay').fadeIn();
    //             $('.video-holder .trigger').fadeIn();
    //     }
    // });


    // $(".video-holder #fade-video").on("finish", function(){
    //     $('.video-holder .overlay').fadeIn();
    //     $('.video-holder .trigger').fadeIn();
    // });

    if($('.filter').length > 0) {
        $('.filter-section .main-link').on('click', function () {
            $('.filter .filter-holder .filter-dropdown').hide();
        });

        $('.drop-trigger-1').on('click', function (e) {
            e.preventDefault();
            $('#drop-1').fadeToggle();
        });
        $('.drop-trigger-2').on('click', function (e) {
            e.preventDefault();
            $('#drop-2').fadeToggle();
        });
        $('.drop-trigger-3').on('click', function (e) {
            e.preventDefault();
            $('#drop-3').fadeToggle();
        });

        $(document).on('click',function (e) {
            var el = '.filter-wrapper .filter';
            if (jQuery(e.target).closest(el).length) return;
            $('.filter .filter-holder .filter-dropdown').fadeOut();
        });
    }

    if($('.clients').length > 0) {
        $('.clients ul li').on('click', function(e) {
            $.fancybox.open( $(this).find('.hidden-bio'), {
                touch: false,
                baseClass: "bio-container"
            });
        });
        $('.clients ul li .details').on('click', function(e) {
            e.preventDefault();
            $.fancybox.open( $(this).find('.hidden-bio'), {
                touch: false,
                baseClass: "bio-container"
            });
        });

        // $('.clients .hover-info .close').on('click', function(e) {
        //     $('.clients .hover-info').removeClass('active');
        // });

        // $(window).on('resize', function () {
        //     $('.clients .hover-info').removeClass('active');
        // });
        //
        // $(document).on('click',function (e) {
        //     var el = '.clients ul li';
        //     if (jQuery(e.target).closest(el).length) return;
        //     $('.clients .hover-info').removeClass('active');
        // });
    }

    if($('.advisors').length > 0) {
        // tabbed content
        $(".tab_content").hide();

        $("ul.tabs li").on('click', function () {
            $(".tab_content").hide();
            var activeTab = $(this).attr("rel");
            $("#"+activeTab).fadeIn();

            $("ul.tabs li").removeClass("active");
            $(this).addClass("active");
        });

        $('ul.tabs li').last().addClass("tab_last");

        $(function($){
            var contents = $('.accordeon-content');
            var titles = $('.accordeon-title');
            titles.on('click',function(){
                var title = $(this);
                contents.filter(':visible').slideUp(function(){
                    $(this).prev('.accordeon-title').removeClass('is-opened');
                });

                var content = title.next('.accordeon-content');

                if (!content.is(':visible')) {
                    content.slideDown(function(){title.addClass('is-opened')});
                }
            });
        });
    }

    /* Home page Map Animation */
    if($('.map-triangles').length > 0) {
        $('.map-triangles.static').css({background:'none',opacity: '1'}).append('<div class="map"><section class="row"><span class="arr up on"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up on"></span><span class="arr dn off"></span></section><section class="row"><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn off"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn off"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up off"></span></section><section class="row"><span class="arr up off"></span><span class="arr dn on"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn on"></span></section><section class="row"><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn on"></span><span class="arr up on"></span><span class="arr dn on"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span><span class="arr dn off"></span><span class="arr up off"></span></section><div class="map-image"></div></div>');
    }
    var arrElems = $('.arr.on');
    setInterval(function(){
        if (arrElems.length > 0) {
            key = Math.floor(Math.random()*(arrElems.length));
            $(arrElems[key]).css({
                borderTopColor:'#EDEDED',
                borderBottomColor:'#F5F5F5'
            });
            arrElems.splice(key,1);
        } else {
            return false;
        }
    }, 100);
    
    /* Map Parallax and Sticky Sidebar */
    if ($('#secondary').length > 0) {
        var sidebarPos = $('#secondary').offset().top;
    }

    if($('.case-studies').length > 0) {
        $(window).on('scroll', function () {
            var winPos = $(window).scrollTop();
            /* Background map parallax */
            var mapPos = winPos * -0.15;
            $('.map-triangles').animate({top: mapPos + 'px'}, 0);
        });
    }

    // if($('.map-triangles').length > 0) {
    //     var arrElems = $('.arr.on');
    //     setTimeout(function(){
    //         function threeArrows(){
    //             const appOpts = window.appOpts || null;
    //             var images = appOpts ? appOpts.triangles : [];
    //
    //             if(typeof images == 'undefined') {
    //                 return;
    //             }
    //
    //             var colorCount = images.length;
    //             var arrCount = jQuery('.arr.on').length;
    //             $('.arr.up.on').css('border-bottom-color', '#F8F8F8');
    //             function arrow() {
    //                 var arrColorKey = Math.ceil((Math.random()*colorCount)-1);
    //                 var arrRanColor = images[arrColorKey];
    //                 var arrows = $('.arr.on');
    //                 var ranKey = Math.ceil((Math.random()*arrCount)-1);
    //                 var ranArrow = arrows[ranKey];
    //                 // $('.arr.up.on').css('border-bottom-color', '#F8F8F8');
    //                 if ($(ranArrow).hasClass('up')) {
    //                     $(ranArrow).css('background-image', "url(" + arrRanColor + ")");
    //                     $(ranArrow).css('border-bottom-color', 'transparent');
    //                 }
    //             }
    //             arrow();
    //             arrow();
    //             arrow();
    //         }threeArrows();
    //         setInterval(function(){threeArrows()},5000);
    //     }, 4000);
    //
    //     //Parallax
    //
    //     $(window).on('scroll', function () {
    //         var scroll = $(window).scrollTop();
    //         $(".parallax").css("transform","translateY(" +  (scroll/5)  + "px)");
    //     });
    // }

    if($('.main-menu').length > 0) {
        var allPanels = $('.sub-menu');

        openMenuFunction = function () {
            if($(window).width() < 992) {
                $('.menu-item-has-children > a').on('click', function() {
                    $('.menu-item-has-children > a').removeClass('active');
                    allPanels.slideUp();
                    $(this).next().slideDown();
                    $(this).addClass('active');
                    return false;
                });
            };
        };

        openMenuFunction();

        $(window).on('resize', function () {
            if($(window).width() > 992) {
                $('.sub-menu').show();
            } else {
                $('.sub-menu').hide();
            }
        });
    }
    //
    // function getHash() {
    //     if (window.location.hash) {
    //         var hash = window.location.hash.substring(1);
    //         var id = $('#'+ hash);
    //         if (hash.length === 0) {
    //             return false;
    //         } else {
    //             $('.tab-link[rel="'+hash+'"]').addClass('active');
    //             $(id).show();
    //             $('html, body').stop().animate({ scrollTop: $(id).offset().top - 200 }, 1500);
    //             console.log('fire')
    //         }
    //     } else {
    //         return false;
    //     }
    // }
    // getHash();

    if($('.custom-experts-list').length > 0) {
        $('.custom-experts-list li a').on('click', function(e) {
            e.preventDefault();
            $.fancybox.open( $(this).parent().find('.hidden-bio'), {
                touch: false,
                baseClass: "bio-container"
            });
        });
    }

    if($('.posts-slider').length > 0) {
        $('.posts-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    if($('header').length > 0) {

        let headerGradient = function() {
            const header = $('header');
            const homeHeader = $('.homepage header');
            const winPos = $(window).scrollTop();

            if(winPos > 0 && homeHeader.length < 1) {
                header.addClass('active');
            } else {
                header.removeClass('active');
            }
        };

        $(window).on('scroll', function () {
            headerGradient();
        });

        headerGradient();
    };
});